<template>
  <div>
    <el-row class="title-bar">
      <span class="mr-r15 c-pointer" @click="onBackButtonClick"><i class="fas fa-long-arrow-left"></i></span>
      <div class="title-h4">IP추가</div>
    </el-row>
    <el-form :model="formData" :rules="formRules" ref="ipForm">
      <el-form-item label="구분">
        <el-select v-model="addType" style="width:100%" @change="initData">
          <el-option v-for="type in addTypes[ipVersion]" :key="type.key" :label="type.label" :value="type.key"></el-option>
        </el-select>
      </el-form-item>
      <div v-if="addType === 'ipaddress'">
        <el-form-item prop="searchKeyword1" label="IP주소">
          <el-input v-model="formData.searchKeyword1" placeholder="IP를 입력하십시오."></el-input>
        </el-form-item>
      </div>
      <div v-else-if="addType === 'iprange'">
        <el-form-item prop="searchKeyword1" label="시작 IP주소">
          <el-input v-model="formData.searchKeyword1" placeholder="IP를 입력하십시오."></el-input>
        </el-form-item>
        <el-form-item prop="searchKeyword2" label="종료 IP주소">
          <el-input v-model="formData.searchKeyword2" placeholder="IP를 입력하십시오."></el-input>
        </el-form-item>
      </div>
      <div v-else-if="addType === 'subnetmask'">
        <el-form-item prop="searchKeyword1" label="IP주소">
          <el-input v-model="formData.searchKeyword1" placeholder="IP를 입력하십시오."></el-input>
        </el-form-item>
        <el-form-item prop="searchKeyword2" label="서브넷 마스크">
          <el-input v-model="formData.searchKeyword2" placeholder="서브넷 마스크를 입력하십시오."></el-input>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { matcher } from '@/utils/string';

export default {
  name: 'WAddIpaddressSettingView',
  props: {
    /**
     * IP 버전에 따른 IP 구분
     * @type {[type]}
     */
    ipVersion: String,
  },
  data() {
    return {
      addType: 'ipaddress',
      addTypes: {
        IPv4: [
          { key: 'ipaddress', label: 'IP주소' },
          { key: 'iprange', label: 'IP범위' },
          { key: 'subnetmask', label: '서브넷마스크' },
        ],
        IPv6: [
          { key: 'ipaddress', label: 'IP주소' },
        ],
      },
      formData: {
        searchKeyword1: '',
        searchKeyword2: '',
      },
      buttonDisabled: true,
      formRules: {
        searchKeyword1: {
          required: true,
          validator: this.vaildateIpaddress,
          trigger: 'blur',
        },
        searchKeyword2: {
          required: true,
          validator: this.vaildateIpaddress,
          trigger: 'blur',
        },
      },
    };
  },
  methods: {
    /**
     * IP추가에 필요한 정보 가공
     * @author jeee12
     */
    getIpaddressInfo() {
      return {
        validate: this.$refs.ipForm.validate, // Promise
        formData: this.formData,
        addType: this.addType,
        ipVersion: this.ipVersion,
      };
    },
    /**
     * 뒤로가기 버튼 click
     * @author jeee12
     * @return {[type]} [description]
     */
    onBackButtonClick() {
      this.$emit('change-view', 'basicInfoView');
      this.addType = 'ipaddress';
    },
    /**
     * ip주소 유효성 검사
     * @author jeee12
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    vaildateIpaddress(rule, value, callback) {
      if (isEmpty(value) || value.length === 0) {
        callback(new Error('값을 입력하십시오.'));
      } else {
        const validateV4 = matcher.ipv4().test(value);
        const validateV6 = matcher.ipv6().test(value);
        if (!(validateV4 || validateV6)) {
          callback(new Error('IP주소 형식이 잘못되었습니다.'));
        }
      }
      callback();
    },
    /**
     * 폼 데이터 초기화
     * @author jeee12
     * @param  {[type]} viewType 기본정보 화면 활성화시 viewType 전달
     * @return {[type]}          [description]
     */
    initData(viewType) {
      if (viewType === 'basicInfoView') {
        this.addType = 'ipaddress';
      }

      this.formData = {
        searchKeyword1: '',
        searchKeyword2: '',
      };

      this.$nextTick(() => {
        this.$refs.ipForm.clearValidate();
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/TrafficSettings/IpGroupSettings/components/AddIpaddressSettingView.vue